module.exports =
  '_GOAL_SETTINGS':
    'TITLE': '目標設定'
    'ALL_USERS_AVG_DATA': "GOLF NETWORK PLUS 会員平均"
    'VALUE_OF_YOUR_GOAL': '目標設定値'
    'AVG_SCORE': '平均スコア'
    'AVG_PUTTS': '平均パット数 (1ホール)'
    'FAIRWAY_HIT': 'フェアウェイキープ率 (%)'
    'GIR': 'パーオン率 (%)'
    'BOGEY_ON': 'ボギーオン率'
    'MY_DATA': 'MY DATA (全期間)'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/goal-settings/i18n/ja.coffee